import { useEffect, useMemo, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { isLoadingByKey } from '../../shared/controls/methods/getLoadingState';
import Loader from '../../shared/component/Loader';
import apiServices from '../../services/service';
import { Link } from 'react-router-dom';
import PipelineDealsByStage from './pipelineDealsByStage';
import { DateFormatter } from '../../shared/controls/formatters';
import { getAttendanceByUserId, getUser, getUserInfo, getUserInformation } from '../../redux/selector';
import { toast } from 'react-toastify';
import { fetchDataAndUpdateStore } from '../../redux/actions';
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";
import { tr } from 'date-fns/locale';

const ConfirmCheckOutModal = ({ show, onConfirm, onCancel }) => {
  return (
    // <div style={{ height: '100%' }}>
    <Modal
      show={show}
      onHide={onCancel}
      centered
      backdrop="static"
      keyboard={false}
      dialogClassName="confirm-checkout-modal"
      animation={true}
    >
      <Modal.Header closeButton className="border-0 pb-0">
        <Modal.Title className="modal-title-custom">
          Confirm Checkout
        </Modal.Title>
      </Modal.Header>

      <Modal.Body className="modal-body-custom">
        <div className="modal-icon-wrapper">
          <svg
            className="modal-icon"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"
            />
          </svg>
        </div>
        <p className="modal-message">
          Are you sure you want to checkout?
        </p>
      </Modal.Body>

      <Modal.Footer className="border-0 pt-0">
        <Button
          variant="secondary"
          onClick={onCancel}
          className="modal-btn modal-btn-cancel"
        >
          No
        </Button>

        <Button
          variant="danger"
          onClick={onConfirm}
          className="modal-btn modal-btn-confirm"
        >
          Yes, Checkout
        </Button>
      </Modal.Footer>
    </Modal>
    // </div>
  );
};

const HomeCRM = () => {
  const stateData = useSelector((state) => state);
  const [leadCount, setLeadCount] = useState();
  const [totalOpenTicket, setTotalOpenTicket] = useState();
  const [openOpportunity, setOpenOpportunity] = useState();
  const [weekTicketList, setWeekTicketList] = useState([]);
  const [todayTicketList, setTodayTicketList] = useState([]);
  const [opportunityList, setOpportunityList] = useState([]);
  const [pipelineData, setPipelineData] = useState([]);
  const [isShowsLoader, setIsShowsLoader] = useState(false);
  const [isVisible, setIsVisible] = useState(true);
  const [isAnimating, setIsAnimating] = useState(false);
  const userInfo = useSelector(getUserInformation);
  const dispatch = useDispatch();
  const [isCheckedIn, setIsCheckedIn] = useState(false);
  const [buttonLabel, setButtonLabel] = useState("Checkin");
  const [showCheckoutConfirm, setShowCheckoutConfirm] = useState(false);
  const AttendanceFlag = process.env.REACT_APP_ATTENDANCE_FLAG === "true";

  // useEffect(() => {
  //   const isDismissed = sessionStorage.getItem('downloadBannerDismissed');
  //   if (isDismissed) {
  //     setIsVisible(false);
  //   }
  // }, []);

  const handleDownload = () => {
    setIsAnimating(true);
    // Wait for animation to complete before hiding
    setTimeout(() => {
      setIsVisible(false);
      setIsAnimating(false);
    }, 400); // Match animation duration
    sessionStorage.setItem('downloadBannerDismissed', 'true');
  };

  let storeLoading = isLoadingByKey(
    stateData,
    'revenueTypeList',
    'leadSourceList',
    'industryList',
    'accountType'
  );
  const containerStyle = useMemo(() => ({ width: '100%', height: '100%' }), []);
  const [loading, setLoading] = useState(storeLoading);

  useEffect(() => {
    setLoading(storeLoading);
  }, [storeLoading]);

  useEffect(() => {
    setLoading(true);
    apiServices
      .getTotalLead()
      .then((response) => {
        if (response.status === 200) {
          const leadCount = response.data;
          setLeadCount(leadCount);
          setLoading(false);
        }
      })
      .catch((error) => {
        console.error('Error', error);
        setLoading(false);
      });
  }, []);

  useEffect(() => {
    setLoading(true);
    apiServices
      .getTotalOpenTicket()
      .then((response) => {
        if (response.status === 200) {
          const ticketCount = response.data;
          setTotalOpenTicket(ticketCount);
          setLoading(false);
        }
      })
      .catch((error) => {
        console.error('Error', error);
        setLoading(false);
      });
  }, []);

  useEffect(() => {
    setLoading(true);
    apiServices
      .getOpenOpportunity()
      .then((response) => {
        if (response.status === 200) {
          const opportunityCount = response.data;
          setOpenOpportunity(opportunityCount);
          setLoading(false);
        }
      })
      .catch((error) => {
        console.error('Error', error);
        setLoading(false);
      });
  }, []);

  useEffect(() => {
    setLoading(true);
    setIsShowsLoader(true);
    apiServices
      .getCrmDashboard()
      .then((response) => {
        if (response.status === 200) {
          const weekTicketList = response.data.ticketthisweek;
          const todayTicketList = response.data.ticketToday;
          const opportunityList = response.data.opportunity;
          setWeekTicketList(weekTicketList);
          setTodayTicketList(todayTicketList);
          setOpportunityList(opportunityList);
          setPipelineData(response?.data?.opportunityStage);
          setLoading(false);
          setIsShowsLoader(false);
        }
      })
      .catch((error) => {
        console.error('Error', error);
        setLoading(false);
      });
  }, []);

  const bannerStyles = `
  @keyframes slideDown {
    from {
      transform: translateY(-100%);
      opacity: 0;
    }
    to {
      transform: translateY(0);
      opacity: 1;
    }
  }

  @keyframes slideUp {
    from {
      transform: translateY(0);
      opacity: 1;
    }
    to {
      transform: translateY(-100%);
      opacity: 0;
    }
  }

  .banner-enter {
    animation: slideDown 0.4s ease-out forwards;
  }

  .banner-exit {
    animation: slideUp 0.4s ease-out forwards;
  }
`;

  const attendanceByUserId = useSelector(getAttendanceByUserId);
  useEffect(() => {
    if (!attendanceByUserId && userInfo) {
      dispatch(
        fetchDataAndUpdateStore({
          key: "attendanceByUserId",
          inputData: userInfo?.userId,
        })
      );
    }
  }, [userInfo]);


  const getTodayAttendance = () => {
    const list = attendanceByUserId?.userAttendance || [];
    const today = new Date().toISOString().split("T")[0]; // YYYY-MM-DD

    return list.find((item) => {
      if (!item?.checkIn) return false;
      return item.checkIn.split("T")[0] === today;
    });
  };


  useEffect(() => {
    const todayRecord = getTodayAttendance();
    if (todayRecord?.checkIn && !todayRecord?.checkOut) {
      setButtonLabel("Checkout");
      setIsCheckedIn(true);
    } else {
      setButtonLabel("Checkin");
      setIsCheckedIn(false);
    }
  }, [attendanceByUserId]);

  const handleCheckinCheckout = async () => {
    const todayRecord = getTodayAttendance();

    // 👉 if already checked in but not checked out → ask confirmation
    if (todayRecord?.checkIn && !todayRecord?.checkOut) {
      setShowCheckoutConfirm(true);
      return;
    }

    // otherwise normal checkin
    await processAttendance();
  };

  const processAttendance = async () => {
    try {
      setLoading(true);

      const currentTime = new Date().toISOString();
      const todayRecord = getTodayAttendance();

      let payload = {
        userId: userInfo?.userId,
        employeeCode: userInfo?.empId,
        status: "Present",
        checkIn: null,
        checkOut: null,
        duration: 0,
      };

      if (!todayRecord) {
        payload.checkIn = currentTime;
      }
      else if (!todayRecord?.checkIn) {
        payload.checkIn = currentTime;
      }
      else if (todayRecord?.checkIn && !todayRecord?.checkOut) {
        payload.checkIn = todayRecord.checkIn;
        payload.checkOut = currentTime;
      }
      else if (todayRecord?.checkIn && todayRecord?.checkOut) {
        toast.info("You already checked out for today");
        setLoading(false);
        return;
      }
      setLoading(true);
      const response = await apiServices.createAttendance(payload);

      if (response.status === 200 || response.status === 204) {
        dispatch(
          fetchDataAndUpdateStore({
            key: "attendanceByUserId",
            inputData: userInfo?.userId,
          })
        );

        toast.success(
          payload.checkOut
            ? "Checked-out successfully!"
            : "Checked-in successfully!"
        );
        setLoading(false);
      } else {
        handleApiErrors(response);
        setLoading(false);
      }
    } catch (error) {
      handleCatchErrors(error);
    } finally {
      setLoading(false);
      setShowCheckoutConfirm(false);
    }
  };





  // const handleCheckinCheckout = async () => {
  //   try {
  //     setLoading(true);

  //     const currentTime = new Date().toISOString();
  //     const todayRecord = getTodayAttendance();

  //     let payload = {
  //       userId: userInfo?.userId,
  //       employeeCode: userInfo?.empId,
  //       status: "Present",
  //       checkIn: null,
  //       checkOut: null,
  //       duration: 0,
  //     };

  //     // 🔵 CASE 1: No record for today → fresh checkin
  //     if (!todayRecord) {
  //       payload.checkIn = currentTime;
  //       payload.checkOut = null;
  //     }

  //     // 🔵 CASE 2: Today record exists but no checkin yet
  //     else if (!todayRecord?.checkIn) {
  //       payload.checkIn = currentTime;
  //       payload.checkOut = null;
  //     }

  //     // 🔵 CASE 3: Checkin exists but checkout not done → DO CHECKOUT
  //     else if (todayRecord?.checkIn && !todayRecord?.checkOut) {
  //       payload.checkIn = todayRecord.checkIn; // send same checkin
  //       payload.checkOut = currentTime;
  //     }

  //     // 🔵 CASE 4: Already checked out today → optional block
  //     else if (todayRecord?.checkIn && todayRecord?.checkOut) {
  //       setLoading(false);
  //       toast.info("You already checked out for today");
  //       return;
  //     }

  //     const response = await apiServices.createAttendance(payload);

  //     if (response.status === 200 || response.status === 204) {
  //       dispatch(
  //         fetchDataAndUpdateStore({
  //           key: "attendanceByUserId",
  //           inputData: userInfo?.userId,
  //         })
  //       );

  //       toast.success(
  //         payload.checkOut ? "Checked-out successfully!" : "Checked-in successfully!"
  //       );
  //     } else {
  //       handleApiErrors(response);
  //     }
  //   } catch (error) {
  //     handleCatchErrors(error);
  //   } finally {
  //     setLoading(false);
  //   }
  // };

  const handleApiErrors = (response) => {
    const errorMessages = [];

    if (response?.errors) {
      for (const key in response.errors) {
        errorMessages.push(...response.errors[key]);
      }
    }

    if (errorMessages.length) {
      errorMessages.forEach((msg) =>
        toast.error(msg, { position: "top-right" })
      );
    } else {
      toast.error("Something went wrong");
    }
  };

  const handleCatchErrors = (error) => {
    if (error?.response?.data?.errors) {
      const errors = error.response.data.errors;
      Object.keys(errors).forEach((key) => {
        errors[key].forEach((msg) => toast.error(msg));
      });
    } else {
      toast.error("Server error occurred");
    }
  };



  return (
    <>
      <style>{bannerStyles}</style>
      {isVisible && (
        <div
          className={`position-fixed top-0 start-0 end-0 bg-primary shadow ${isAnimating ? 'banner-exit' : 'banner-enter'
            }`}
          style={{ zIndex: 99999 }}
        >
          <div className="container-fluid">
            <div className="d-flex align-items-center justify-content-between py-3 px-3">
              <div className="d-flex align-items-center flex-grow-1">
                <svg
                  className="me-3 text-white"
                  width="24"
                  height="24"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M12 18h.01M8 21h8a2 2 0 002-2V5a2 2 0 00-2-2H8a2 2 0 00-2 2v14a2 2 0 002 2z"
                  />
                </svg>
                <span className="text-white fw-semibold">
                  Get our mobile app for the best experience!
                </span>
              </div>

              <div className="d-flex align-items-center gap-2">
                <Link
                  href="/assets/leadTrack.apk"
                  download="leadTrack.apk"
                  onClick={handleDownload}
                  className="btn btn-light btn-sm fw-semibold text-nowrap"
                >
                  Download APK
                </Link>

                <button
                  onClick={handleDownload}
                  className="btn btn-link text-white p-1"
                  aria-label="Close banner"
                  style={{ textDecoration: 'none' }}
                >
                  <svg width="20" height="20" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M6 18L18 6M6 6l12 12"
                    />
                  </svg>
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
      <div className="inner-page" style={containerStyle}>
        <div className="home-content">
          {loading && <Loader />}
          <div className="flex_boxes">
            <div className="grid-container-box">
              <div className="grid-box bg-lightblue">
                <svg
                  width="50"
                  height="50"
                  viewBox="0 0 62 62"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <defs>
                    <linearGradient
                      id="linear-gradient"
                      x1="0.5"
                      x2="0.5"
                      y2="1"
                      gradientUnits="objectBoundingBox"
                    >
                      <stop offset="0" stopColor="#E9ECFD" />
                      <stop offset="1" stopColor="#EED8FA" />
                    </linearGradient>
                  </defs>
                  <rect
                    x="2"
                    y="2"
                    width="58"
                    height="58"
                    rx="29"
                    fill="url(#linear-gradient)"
                    stroke="white"
                    strokeWidth="8"
                  />
                  <path
                    d="M22.9194 37.657L35.6655 19.4486C35.7384 19.3374 35.8328 19.242 35.9433 19.168C36.0537 19.094 36.1779 19.043 36.3085 19.0179C36.439 18.9928 36.5733 18.9941 36.7033 19.0219C36.8333 19.0496 36.9564 19.1032 37.0654 19.1794C37.1743 19.2556 37.2668 19.3529 37.3375 19.4655C37.4081 19.5782 37.4554 19.7038 37.4765 19.8351C37.4977 19.9663 37.4923 20.1005 37.4606 20.2296C37.429 20.3587 37.3717 20.4802 37.2923 20.5868L23.9582 39.6354C23.882 39.7447 23.7845 39.8376 23.6716 39.9084C23.5587 39.9793 23.4327 40.0267 23.3011 40.0478C23.1695 40.0689 23.035 40.0633 22.9056 40.0314C22.7762 39.9994 22.6546 39.9418 22.5479 39.8618L15.3973 34.4988C15.2929 34.4206 15.205 34.3225 15.1386 34.2103C15.0721 34.0981 15.0284 33.9739 15.01 33.8448C14.9727 33.584 15.0406 33.3191 15.1986 33.1084C15.3567 32.8977 15.5919 32.7584 15.8527 32.7211C16.1135 32.6839 16.3783 32.7517 16.589 32.9098L22.9194 37.657ZM37.0479 28.1685C36.7845 28.1685 36.5319 28.0638 36.3457 27.8776C36.1594 27.6913 36.0548 27.4387 36.0548 27.1753C36.0548 26.9119 36.1594 26.6593 36.3457 26.4731C36.5319 26.2868 36.7845 26.1822 37.0479 26.1822H43.0068C43.2703 26.1822 43.5229 26.2868 43.7091 26.4731C43.8954 26.6593 44 26.9119 44 27.1753C44 27.4387 43.8954 27.6913 43.7091 27.8776C43.5229 28.0638 43.2703 28.1685 43.0068 28.1685H37.0479ZM33.0753 34.1274C32.8119 34.1274 32.5593 34.0228 32.3731 33.8365C32.1868 33.6502 32.0822 33.3976 32.0822 33.1342C32.0822 32.8708 32.1868 32.6182 32.3731 32.432C32.5593 32.2457 32.8119 32.1411 33.0753 32.1411H43.0049C43.2683 32.1411 43.5209 32.2457 43.7071 32.432C43.8934 32.6182 43.998 32.8708 43.998 33.1342C43.998 33.3976 43.8934 33.6502 43.7071 33.8365C43.5209 34.0228 43.2683 34.1274 43.0049 34.1274H33.0753ZM29.1027 40.0863C28.8393 40.0863 28.5867 39.9817 28.4005 39.7954C28.2142 39.6092 28.1096 39.3565 28.1096 39.0931C28.1096 38.8297 28.2142 38.5771 28.4005 38.3909C28.5867 38.2046 28.8393 38.1 29.1027 38.1H43.0049C43.2683 38.1 43.5209 38.2046 43.7071 38.3909C43.8934 38.5771 43.998 38.8297 43.998 39.0931C43.998 39.3565 43.8934 39.6092 43.7071 39.7954C43.5209 39.9817 43.2683 40.0863 43.0049 40.0863H29.1027Z"
                    fill="#456ABB"
                  />
                </svg>

                <div className="flex_text">
                  <h2>{openOpportunity}</h2>
                  <p>Open Opportunities</p>
                </div>
              </div>

              <div className="grid-box bg-lightgreen">
                <svg
                  width="50"
                  height="50"
                  viewBox="0 0 62 62"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <defs>
                    <linearGradient
                      id="linear-gradient"
                      x1="0.5"
                      x2="0.5"
                      y2="1"
                      gradientUnits="objectBoundingBox"
                    >
                      <stop offset="0" stopColor="#E9ECFD" />
                      <stop offset="1" stopColor="#EED8FA" />
                    </linearGradient>
                  </defs>
                  <rect
                    x="2"
                    y="2"
                    width="58"
                    height="58"
                    rx="29"
                    fill="url(#linear-gradient)"
                    stroke="white"
                    strokeWidth="6"
                  />
                  <path
                    d="M39.8438 41.8333L42 44M29.0625 33.8889C23.5051 33.8889 19 38.4158 19 44H29.0625M40.5625 38.9444C40.5625 40.9388 38.9535 42.5556 36.9688 42.5556C34.984 42.5556 33.375 40.9388 33.375 38.9444C33.375 36.9501 34.984 35.3333 36.9688 35.3333C38.9535 35.3333 40.5625 36.9501 40.5625 38.9444ZM34.8125 23.7778C34.8125 26.9688 32.2381 29.5556 29.0625 29.5556C25.8869 29.5556 23.3125 26.9688 23.3125 23.7778C23.3125 20.5868 25.8869 18 29.0625 18C32.2381 18 34.8125 20.5868 34.8125 23.7778Z"
                    stroke="#456ABB"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>

                <div className="flex_text">
                  <h2>{leadCount}</h2>
                  <p>Total Leads</p>
                </div>
              </div>

              <div className="grid-box bg-lightorange">
                <svg
                  width="50"
                  height="50"
                  viewBox="0 0 62 62"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <defs>
                    <linearGradient
                      id="linear-gradient"
                      x1="0.5"
                      x2="0.5"
                      y2="1"
                      gradientUnits="objectBoundingBox"
                    >
                      <stop offset="0" stopColor="#E9ECFD" />
                      <stop offset="1" stopColor="#EED8FA" />
                    </linearGradient>
                  </defs>
                  <rect
                    x="2"
                    y="2"
                    width="58"
                    height="58"
                    rx="29"
                    fill="url(#linear-gradient)"
                    stroke="white"
                    strokeWidth="3"
                  />
                  <path
                    d="M42.5 20.75H37.25V18.75C37.25 18.6125 37.1375 18.5 37 18.5H35.25C35.1125 18.5 35 18.6125 35 18.75V20.75H27V18.75C27 18.6125 26.8875 18.5 26.75 18.5H25C24.8625 18.5 24.75 18.6125 24.75 18.75V20.75H19.5C18.9469 20.75 18.5 21.1969 18.5 21.75V42.5C18.5 43.0531 18.9469 43.5 19.5 43.5H42.5C43.0531 43.5 43.5 43.0531 43.5 42.5V21.75C43.5 21.1969 43.0531 20.75 42.5 20.75ZM41.25 41.25H20.75V23H24.75V24.5C24.75 24.6375 24.8625 24.75 25 24.75H26.75C26.8875 24.75 27 24.6375 27 24.5V23H35V24.5C35 24.6375 35.1125 24.75 35.25 24.75H37C37.1375 24.75 37.25 24.6375 37.25 24.5V23H41.25V41.25ZM36.5 28.125H34.775C34.6156 28.125 34.4625 28.2031 34.3687 28.3313L29.6531 34.825L27.6313 32.0438C27.5375 31.9156 27.3875 31.8375 27.225 31.8375H25.5C25.2969 31.8375 25.1781 32.0688 25.2969 32.2344L29.2469 37.6719C29.2936 37.7358 29.3547 37.7878 29.4253 37.8237C29.4959 37.8595 29.574 37.8782 29.6531 37.8782C29.7323 37.8782 29.8104 37.8595 29.8809 37.8237C29.9515 37.7878 30.0127 37.7358 30.0594 37.6719L36.7031 28.525C36.8219 28.3562 36.7031 28.125 36.5 28.125Z"
                    fill="#456ABB"
                  />
                </svg>

                <div className="flex_text">
                  <h2>{totalOpenTicket}</h2>
                  <p>Open Tickets</p>
                </div>
              </div>
            </div>
          </div>
          <div className="row" style={{ margin: '0 8px' }}>
            {AttendanceFlag && (
              <div className="col-xl-3 col-lg-4 col-md-12">
                <div className="card shadow-sm h-100" style={{ borderRadius: "12px" }}>
                  <div className="card-body p-3">
                    <div className="text-center">
                      <div className="profile-img-container mx-auto mb-2">
                        <img
                          src='/assets/images/profile.png'
                          alt="John Smith"
                        />
                        <div className="status-dot"></div>
                      </div>
                      <div className="fw-bold">
                        {userInfo?.empId ? (`${userInfo?.empId} -`) : null} {userInfo?.display_name}
                      </div>
                      <br></br>
                      <div className="text-muted small" style={{ textAlign: "center" }}> {userInfo?.position}</div>

                      <button
                        className={buttonLabel === "Checkin" ? "btn btn-checkIn w-100" : "btn btn-danger w-100"}
                        onClick={handleCheckinCheckout}
                        disabled={loading}
                      >
                        {loading ? 'Please wait...' : buttonLabel}
                      </button>
                    </div>

                    <hr />

                    <div className="small">
                      <p>
                        <strong>Email:</strong>
                        {/* <br /> */}
                        {userInfo?.userName}
                      </p>
                      <p>
                        <strong>Location:</strong>
                        {/* <br /> */}
                        {userInfo?.location}
                      </p>
                      <p>
                        <strong>Department:</strong>
                        {/* <br /> */}
                        {userInfo?.businessUnit}
                      </p>
                      <p>
                        <strong>Shift:</strong>
                        {/* <br /> */}
                        General - 09:30 AM - 06:30 PM
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            )}
            <div className={AttendanceFlag ? "col-xl-9 col-lg-8 col-md-12" : "col-12"}>
              <div className="grid-cards" style={{ margin: "0" }}>
                <div className="cardboxes">
                  <div className="card">
                    <div className="card-header">
                      <div className="title-left-hd">
                        <div className="attachment-background"></div>
                        <div className="title-heading">My Tickets</div>
                      </div>
                      <div className=" justify-content-center dsk">
                        <ul className="nav nav-tabs">
                          <li className="nav-item">
                            <a className="nav-link active" href="#tab1" data-bs-toggle="tab">
                              This Week ({weekTicketList.length})
                            </a>
                          </li>
                          <li className="nav-item">
                            <a className="nav-link" href="#tab2" data-bs-toggle="tab">
                              Today ({todayTicketList.length})
                            </a>
                          </li>
                        </ul>
                      </div>
                      <Link className="next-page-btn" to={`/tickets`}>
                        <svg
                          id="Component_28_1"
                          data-name="Component 28 – 1"
                          xmlns="http://www.w3.org/2000/svg"
                          width="32"
                          height="32"
                          viewBox="0 0 32 32"
                        >
                          <circle
                            id="Ellipse_45"
                            data-name="Ellipse 45"
                            cx="16"
                            cy="16"
                            r="16"
                            fill="none"
                          ></circle>
                          <path
                            id="Icon_ionic-ios-arrow-round-forward"
                            data-name="Icon ionic-ios-arrow-round-forward"
                            d="M18.869,11.472a.782.782,0,0,0-.006,1.1L22.5,16.22H8.647a.778.778,0,0,0,0,1.557H22.5l-3.641,3.647a.788.788,0,0,0,.006,1.1.775.775,0,0,0,1.1-.006l4.934-4.97h0a.874.874,0,0,0,.162-.246.743.743,0,0,0,.06-.3.781.781,0,0,0-.222-.545l-4.934-4.97A.763.763,0,0,0,18.869,11.472Z"
                            fill="#000"
                          ></path>
                        </svg>
                      </Link>
                    </div>

                    <div className="card-body">
                      <div className=" justify-content-center mob">
                        <ul className="nav nav-tabs">
                          <li className="nav-item">
                            <a className="nav-link active" href="#tab1" data-bs-toggle="tab">
                              This Week ({weekTicketList.length})
                            </a>
                          </li>
                          <li className="nav-item">
                            <a className="nav-link" href="#tab2" data-bs-toggle="tab">
                              Today ({todayTicketList.length})
                            </a>
                          </li>
                        </ul>
                      </div>
                      <div className="tab-content">
                        <div className="tab-pane fade show active" id="tab1">
                          <div className="card-text dsk">
                            <div className="home_grid">
                              <table className="table custom-table mb-0">
                                <tbody>
                                  {isShowsLoader ? ( // Check if loading is true
                                    <tr>
                                      <td colSpan="4" style={{ textAlign: 'center' }}>
                                        <div className="loader"></div>{' '}
                                        {/* Add your loader here */}
                                        Loading...
                                      </td>
                                    </tr>
                                  ) : weekTicketList && weekTicketList.length > 0 ? (
                                    weekTicketList.map((ticket, index) => (
                                      <tr key={index}>
                                        <td>
                                          <p>{ticket.description}</p>
                                          <Link>{ticket.subject}</Link>
                                        </td>
                                        <td>
                                          <div className="active">
                                            <span className="dotsactive"></span>
                                            <Link>{ticket.status}</Link>
                                          </div>
                                        </td>
                                        <td>
                                          <div className="highpriority">
                                            <Link>{ticket.priority}</Link>
                                          </div>
                                        </td>
                                        <td>
                                          <Link>{DateFormatter(ticket.dueDate)}</Link>
                                        </td>
                                      </tr>
                                    ))
                                  ) : (
                                    <tr>
                                      <td colSpan="4" style={{ textAlign: 'center' }}>
                                        No tickets available
                                      </td>
                                    </tr>
                                  )}
                                </tbody>
                              </table>
                            </div>
                          </div>
                          <div className="card-text mob">
                            <div className="myTicketBlock">
                              {isShowsLoader ? ( // Check if loading is true
                                <div>
                                  <div style={{ textAlign: 'center' }}>
                                    <div className="loader"></div> {/* Add your loader here */}
                                    Loading...
                                  </div>
                                </div>
                              ) : weekTicketList && weekTicketList.length > 0 ? (
                                weekTicketList.map((ticket, index) => (
                                  <div key={index} className="myTicketOuterBlock">
                                    <div className="myTicketInner">
                                      <p>{ticket.description}</p>
                                      <Link className="subjectName">{ticket.subject}</Link>
                                    </div>
                                    <div className="myTicketInner statusBlock">
                                      <div className="active">
                                        <span className="dotsactive"></span>
                                        <Link>{ticket.status}</Link>
                                      </div>
                                      <div className="highpriority">
                                        <Link>{ticket.priority}</Link>
                                      </div>
                                    </div>

                                    <div className="myTicketInner">
                                      <Link className="dateBlk">
                                        <i className="bi bi-calendar"></i>{' '}
                                        {DateFormatter(ticket.dueDate)}
                                      </Link>
                                    </div>
                                  </div>
                                ))
                              ) : (
                                <div>
                                  <div style={{ textAlign: 'center' }}>No tickets available</div>
                                </div>
                              )}
                            </div>
                          </div>
                        </div>
                        <div className="tab-pane fade" id="tab2">
                          <div className="card-text dsk">
                            <div className="home_grid">
                              <table className="table table-striped">
                                <tbody>
                                  {isShowsLoader ? ( // Check if loading is true
                                    <tr>
                                      <td colSpan="4" style={{ textAlign: 'center' }}>
                                        <div className="loader"></div>{' '}
                                        {/* Add your loader here */}
                                        Loading...
                                      </td>
                                    </tr>
                                  ) : todayTicketList && todayTicketList.length > 0 ? (
                                    todayTicketList.map((ticket, index) => (
                                      <tr key={index}>
                                        <td>
                                          <p>{ticket.description}</p>
                                          <Link>{ticket.subject}</Link>
                                        </td>
                                        <td>
                                          <div className="active">
                                            <span className="dotsactive"></span>
                                            <Link>{ticket.status}</Link>
                                          </div>
                                        </td>
                                        <td>
                                          <div className="highpriority">
                                            <Link>{ticket.priority}</Link>
                                          </div>
                                        </td>
                                        <td>
                                          <Link>{DateFormatter(ticket.dueDate)}</Link>
                                        </td>
                                      </tr>
                                    ))
                                  ) : (
                                    <tr>
                                      <td colSpan="4">
                                        <div
                                          className="noDataBlock"
                                          style={{ height: 'calc(100vh - 384px)' }}
                                        >
                                          <div className="NodataContent">
                                            <img src="../assets/images/empty-box.png" alt="" />
                                            <p>No Tickets Available.</p>
                                          </div>
                                        </div>
                                      </td>
                                    </tr>
                                  )}
                                </tbody>
                              </table>
                            </div>
                          </div>
                          <div className="card-text mob">
                            <div className="myTicketBlock">
                              {isShowsLoader ? ( // Check if loading is true
                                <div>
                                  <div style={{ textAlign: 'center' }}>
                                    <div className="loader"></div> {/* Add your loader here */}
                                    Loading...
                                  </div>
                                </div>
                              ) : todayTicketList && todayTicketList.length > 0 ? (
                                todayTicketList.map((ticket, index) => (
                                  <div key={index} className="myTicketOuterBlock">
                                    <div className="myTicketInner">
                                      <p>{ticket.description}</p>
                                      <Link className="subjectName">{ticket.subject}</Link>
                                    </div>
                                    <div className="myTicketInner statusBlock">
                                      <div className="active">
                                        <span className="dotsactive"></span>
                                        <Link>{ticket.status}</Link>
                                      </div>
                                      <div className="highpriority">
                                        <Link>{ticket.priority}</Link>
                                      </div>
                                    </div>

                                    <div className="myTicketInner">
                                      <Link className="dateBlk">
                                        <i className="bi bi-calendar"></i>{' '}
                                        {DateFormatter(ticket.dueDate)}
                                      </Link>
                                    </div>
                                  </div>
                                ))
                              ) : (
                                <div
                                  className="noDataBlock"
                                  style={{ height: 'calc(100vh - 384px)' }}
                                >
                                  <div className="NodataContent">
                                    <img src="../assets/images/empty-box.png" alt="" />
                                    <p>No Tickets Available.</p>
                                  </div>
                                </div>
                              )}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="cardboxes graphCard">
                  <div className="card">
                    <div className="card-header">
                      <div className="title-left-hd">
                        <div className="attachment-background3"></div>
                        <div className="title-heading">Opportunity by Stages</div>
                      </div>
                      <Link className="next-page-btn" to={`/opportunity`}>
                        <svg
                          id="Component_28_1"
                          data-name="Component 28 – 1"
                          xmlns="http://www.w3.org/2000/svg"
                          width="32"
                          height="32"
                          viewBox="0 0 32 32"
                        >
                          <circle
                            id="Ellipse_45"
                            data-name="Ellipse 45"
                            cx="16"
                            cy="16"
                            r="16"
                            fill="none"
                          ></circle>
                          <path
                            id="Icon_ionic-ios-arrow-round-forward"
                            data-name="Icon ionic-ios-arrow-round-forward"
                            d="M18.869,11.472a.782.782,0,0,0-.006,1.1L22.5,16.22H8.647a.778.778,0,0,0,0,1.557H22.5l-3.641,3.647a.788.788,0,0,0,.006,1.1.775.775,0,0,0,1.1-.006l4.934-4.97h0a.874.874,0,0,0,.162-.246.743.743,0,0,0,.06-.3.781.781,0,0,0-.222-.545l-4.934-4.97A.763.763,0,0,0,18.869,11.472Z"
                            fill="#000"
                          ></path>
                        </svg>
                      </Link>
                    </div>

                    <div className="card-body">
                      <div
                        className="tab-content graphContent"
                        style={{ display: 'flex', alignItems: 'center' }}
                      >
                        {isShowsLoader ? ( // Check if loading is true
                          <table className="table ">
                            <tbody>
                              <tr>
                                <td colSpan="4" style={{ textAlign: 'center' }}>
                                  <div className="loader"></div> {/* Add your loader here */}
                                  Loading...
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        ) : (
                          pipelineData.length > 0 && (
                            <PipelineDealsByStage apiData={pipelineData} />
                          )
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="grid-cards" style={{ gridTemplateColumns: 'repeat(1, 100%)', margin: "0" }}>
                <div className="cardboxes" style={{ marginBottom: "0" }}>
                  <div className="card">
                    <div className="card-header">
                      <div className="title-left-hd">
                        <div className="attachment-background2"></div>
                        <div className="title-heading">Recent Open Opportunities</div>
                      </div>

                      <Link className="next-page-btn" to={`/opportunity`}>
                        <svg
                          id="Component_28_1"
                          data-name="Component 28 – 1"
                          xmlns="http://www.w3.org/2000/svg"
                          width="32"
                          height="32"
                          viewBox="0 0 32 32"
                        >
                          <circle
                            id="Ellipse_45"
                            data-name="Ellipse 45"
                            cx="16"
                            cy="16"
                            r="16"
                            fill="none"
                          ></circle>
                          <path
                            id="Icon_ionic-ios-arrow-round-forward"
                            data-name="Icon ionic-ios-arrow-round-forward"
                            d="M18.869,11.472a.782.782,0,0,0-.006,1.1L22.5,16.22H8.647a.778.778,0,0,0,0,1.557H22.5l-3.641,3.647a.788.788,0,0,0,.006,1.1.775.775,0,0,0,1.1-.006l4.934-4.97h0a.874.874,0,0,0,.162-.246.743.743,0,0,0,.06-.3.781.781,0,0,0-.222-.545l-4.934-4.97A.763.763,0,0,0,18.869,11.472Z"
                            fill="#000"
                          ></path>
                        </svg>
                      </Link>
                    </div>

                    <div className="card-body">
                      <div className="tab-content" style={{ height: 'calc(100vh - 78vh)' }}>
                        <div className="tab-pane fade show active" id="tab1">
                          <div className="card-text dsk">
                            <div className="home_grid">
                              <table className="table table-striped custom-table ">
                                <thead>
                                  <tr>
                                    <th>Name</th>
                                    <th>Account Name</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  {isShowsLoader ? (
                                    <tr>
                                      <td colSpan="4" style={{ textAlign: 'center' }}>
                                        <div className="loader"></div> Loading...
                                      </td>
                                    </tr>
                                  ) : opportunityList && opportunityList.length > 0 ? (
                                    opportunityList.map((opportunity, index) => (
                                      <tr key={index}>
                                        <td>
                                          <Link>{opportunity.name}</Link>
                                        </td>
                                        <td>
                                          <Link>{opportunity.accountName}</Link>
                                        </td>
                                      </tr>
                                    ))
                                  ) : (
                                    <tr>
                                      <td colSpan="2">
                                        <div className="noDataBlock">
                                          <div className="NodataContent">
                                            <img src="../assets/images/empty-box.png" alt="" />
                                            <p>No Opportunities Available.</p>
                                          </div>
                                        </div>
                                      </td>
                                    </tr>
                                  )}
                                </tbody>
                              </table>
                            </div>
                          </div>
                          <div className="card-text mob">
                            <div className="recentOpp ">
                              {isShowsLoader ? (
                                <div style={{ textAlign: 'center' }}>
                                  <div className="loader"></div> Loading...
                                </div>
                              ) : opportunityList && opportunityList.length > 0 ? (
                                opportunityList.map((opportunity, index) => (
                                  <div key={index} className="recentOppBlock">
                                    <div className="recentOppName">
                                      <Link>{opportunity.name}</Link>
                                    </div>
                                    <div className="recentOppAccountName">
                                      <Link>{opportunity.accountName}</Link>
                                    </div>
                                  </div>
                                ))
                              ) : (
                                <div className="noDataBlock">
                                  <div className="NodataContent">
                                    <img src="../assets/images/empty-box.png" alt="" />
                                    <p>No Opportunities Available.</p>
                                  </div>
                                </div>
                              )}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {/* </div> */}
        </div>
      </div>

      {setShowCheckoutConfirm && (
        <div>
          <ConfirmCheckOutModal
            show={showCheckoutConfirm}
            onConfirm={processAttendance}
            onCancel={() => setShowCheckoutConfirm(false)}
          />
        </div>
      )}


    </>

  );
};

export default HomeCRM;
